module.exports = __webpack_public_path__ + "static/media/transportes.d6ff9e02.svg";